import {
  GET_USER_ACTIVITY,
  GET_USER_ACTIVITY_SUCCESS,
  GET_USER_ACTIVITY_ERROR,
  GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY,
  GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS,
  GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR,
  UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY,
  UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS,
  UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR,
} from "./actionTypes"
import { buildPaginationCacheKey } from "helpers/sf_utils"

const INIT_STATE = {
  admin_user_activity: [],
  error: null,
  loading: false,
  // Pagination states
  last_page_fetched: 0,
  total_number_of_pages: 0,
  has_next_page: false,
  has_lookahead_pages: false,
  active_cache_key: null,
  page_cache: {},
  // Column preference states
  admin_user_column_preference_user_activity: [],
  admin_user_column_preference_user_activity_loading: false,
  admin_user_column_preference_user_activity_error: null,
}
const AdminUserActivity = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_ACTIVITY:
      let page_number = 1
      const appendResults = Boolean(action.payload?.appendResults)
      if (action.paginated) {
        page_number = action.payload?.queryParams?.page_number
      }
      const useCache = Boolean(action.payload?.useCache)
      const queryParams = action.payload?.queryParams || {}
      const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
      const shouldResetCache =
        useCache &&
        page_number === 1 &&
        !appendResults &&
        state.active_cache_key &&
        state.active_cache_key !== cacheKey
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[page_number] : null

      return {
        ...state,
        active_cache_key: useCache ? cacheKey : null,
        loading: !cachedPage,
        admin_user_activity: cachedPage?.rows || ((page_number === 1 || !appendResults) ? [] : state.admin_user_activity),
        last_page_fetched: cachedPage?.page_number || state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
        has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
        has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean' ? cachedPage.has_lookahead_pages : state.has_lookahead_pages,
        page_cache: shouldResetCache ? {} : state.page_cache,
      }

    case GET_USER_ACTIVITY_SUCCESS:
      let uniqueRows = [];
      const appendUserActivity = Boolean(action.meta?.appendResults)
      const rows = Array.isArray(action.payload.data) ? action.payload.data : []
      const Rows = appendUserActivity ? [...state.admin_user_activity, ...rows] : rows
      const useCacheForSuccess = Boolean(action.meta?.useCache)
      const successQueryParams = action.meta?.queryParams || {}
      const successCacheKey = useCacheForSuccess ? buildPaginationCacheKey(successQueryParams) : null
      const safePage = parseInt(action.payload.additional_data?.page_number, 10) || 1
      const safeTotal = parseInt(action.payload.additional_data?.total_number_of_pages, 10) || 0
      const pageSnapshot = {
        rows,
        page_number: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: action.payload.additional_data?.has_next_page || false,
        has_lookahead_pages: action.payload.additional_data?.has_lookahead_pages || false,
      }
      Rows.forEach(function (item) {
        const i = uniqueRows.findIndex(x => x.id == item.id);
        if (i <= -1) {
          uniqueRows.push(item);
        }
      });

      return {
        ...state,
        active_cache_key: useCacheForSuccess ? successCacheKey : state.active_cache_key,
        admin_user_activity: uniqueRows,
        last_page_fetched: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: action.payload.additional_data?.has_next_page,
        has_lookahead_pages: action.payload.additional_data?.has_lookahead_pages || false,
        loading: false,
        page_cache: useCacheForSuccess ? {
          ...state.page_cache,
          [successCacheKey]: {
            ...(state.page_cache?.[successCacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.page_cache,
      }


    case GET_USER_ACTIVITY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        has_next_page: false,
        has_lookahead_pages: false
      }

    case GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY:
      return {
        ...state,
        admin_user_column_preference_user_activity_loading: true,
      }

    case GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS:
      return {
        ...state,
        admin_user_column_preference_user_activity_loading: false,
        admin_user_column_preference_user_activity: action.payload
      }

    case GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR:
      return {
        ...state,
        admin_user_column_preference_user_activity_loading: false,
        admin_user_column_preference_user_activity_error: action.payload
      }

    case UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY:
      return {
        ...state,
        admin_user_column_preference_user_activity_loading: true,
      }

    case UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS:
      return {
        ...state,
        admin_user_column_preference_user_activity_loading: false,
        admin_user_column_preference_user_activity: action.payload
      }

    case UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR:
      return {
        ...state,
        admin_user_column_preference_user_activity_loading: false,
        admin_user_column_preference_user_activity_error: action.payload
      }

    default:
      return state
  }
}

export default AdminUserActivity
